import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import { MagicField } from '../../../../Enums/MagicField.enum';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import useHealthPlanLaboratoryExamForm from '../../Hooks/useHealthPlanLaboratoryExamForm';
import HealthPlanPrintPdfModal from '../HealthPlanPrintPdf/HealthPlanPrintPdfModal';
import { updateHealthPlanUserItem } from '../../Services/healthPlan.service';

interface HealthPlanLaboratoryExamProps {
	onSuccess?: any;
	disableSubmit?: boolean;
}

export default function HealthPlanLaboratoryExam(
	props: HealthPlanLaboratoryExamProps,
) {
	const { onSuccess, disableSubmit } = props;
	const [initialized, setInitialized] = useState(false);
	const [defaultData, setDefaultData] = useState(null);
	const [printModalOpen, setPrintModalOpen] = useState(false);
	const { healthPlanUser, activeHealthPlanUserItem } = useHealthPlanContext();
	const { formScheme } = useHealthPlanLaboratoryExamForm();

	useEffectAsync(async () => {
		setDefaultData(activeHealthPlanUserItem?.extra?.data ?? null);

		setInitialized(true);
	});

	const handleSave = async (values: any) => {
		for (const valueKey of Object.keys(values)) {
			const value = values[valueKey];
			if (valueKey.indexOf('Radio') !== -1) {
				values[value] = true;
			}
		}

		if (healthPlanUser?.healthPlanId && activeHealthPlanUserItem?.id) {
			await updateHealthPlanUserItem({
				healthPlanId: healthPlanUser.healthPlanId,
				healthPlanUserId: healthPlanUser.id,
				healthPlanItemId: activeHealthPlanUserItem.id,
				data: {
					extra: {
						data: values,
					},
				},
			});
			setPrintModalOpen(true);
		}
	};

	const handleAfterPrint = async () => {
		setPrintModalOpen(false);
		onSuccess && onSuccess();
	};

	if (!initialized) {
		return <FullPageLoading />;
	}

	return (
		initialized && (
			<>
				<Text
					className='danger-text text-center mb-4'
					tx={'diabetes.healthPlanDefaultChange'}
				/>
				<MagicForm
					formScheme={formScheme}
					defaultValues={defaultData}
					onSubmit={handleSave}
					disableSubmit={disableSubmit}
				/>
				<HealthPlanPrintPdfModal
					opened={printModalOpen}
					onClose={handleAfterPrint}
					healthPlanUser={healthPlanUser}
					healthPlanUserItem={activeHealthPlanUserItem}
				/>
			</>
		)
	);
}
